import { render, staticRenderFns } from "./MediabankSelector.vue?vue&type=template&id=0033d350&"
import script from "./MediabankSelector.vue?vue&type=script&lang=js&"
export * from "./MediabankSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports